/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Code_BodyInputs */

const en_signin_code_body = /** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the 6-digit code from your authenticator app.`)
};

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const ar_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const he_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const ur_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const es_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const fr_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const de_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const pt_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const hi_signin_code_body = en_signin_code_body;

/** @type {(inputs: Signin_Code_BodyInputs) => LocalizedString} */
const bn_signin_code_body = en_signin_code_body;

/**
* | output |
* | --- |
* | "Enter the 6-digit code from your authenticator app." |
*
* @param {Signin_Code_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_code_body = /** @type {((inputs?: Signin_Code_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_code_body(inputs)
	if (locale === "he") return he_signin_code_body(inputs)
	if (locale === "ur") return ur_signin_code_body(inputs)
	if (locale === "es") return es_signin_code_body(inputs)
	if (locale === "fr") return fr_signin_code_body(inputs)
	if (locale === "de") return de_signin_code_body(inputs)
	if (locale === "pt") return pt_signin_code_body(inputs)
	if (locale === "hi") return hi_signin_code_body(inputs)
	if (locale === "bn") return bn_signin_code_body(inputs)
	return /** @type {LocalizedString} */ ("Enter the 6-digit code from your authenticator app.")
});